import { css } from '@emotion/react';

const textStyles = css``;

export const themeTextStyles = css`
    color: var(--default-text-color);
`;

export default textStyles;
